import React from 'react';
import {connect} from 'react-redux';

import {assert} from 'Asserts';
import {TargetEntry} from 'folder-items/FileConstants';
import {EntrySummary} from 'notebook/ELNConstants';
import EntrySearchInput from 'notebook/entries/EntrySearchInput';
import {BenchlingState} from 'redux-stores/reduceApp';
import {BenchlingDispatch} from 'redux-stores/Store';
import {RequestFulfillmentDefinition} from 'requests/fulfillments/FulfillmentConstants';
import * as FulfillmentReduxActions from 'requests/fulfillments/FulfillmentReduxActions';
import Modal from 'ui-library/modals/Modal';

import {setSelectedEntry} from './ExistingEntryReduxActions';

interface OwnProps {
  fulfillments: Array<RequestFulfillmentDefinition>;
  onRequestClose: () => void;
}
interface ConnectedProps {
  selectedEntry: EntrySummary | null;
}
interface DispatchProps {
  onSetSelectedEntry: (selectedEntry: EntrySummary | TargetEntry | null) => void;
  onExecuteIntoExistingEntry: (
    entryId: string,
    fulfillments: Array<RequestFulfillmentDefinition>
  ) => Promise<void>;
}
type Props = OwnProps & ConnectedProps & DispatchProps;
interface State {
  currentlySubmitting: boolean;
}

/**
 * Component to select existing entry to execute fulfillments into
 */
class SelectExistingEntryModal extends React.Component<Props, State> {
  override state: State = {
    currentlySubmitting: false,
  };

  _canSubmit(): boolean {
    return !this.state.currentlySubmitting && Boolean(this.props.selectedEntry);
  }

  _handleSelectedEntriesChange = (selectedEntries: Array<EntrySummary | TargetEntry>): void => {
    const selectedEntry = selectedEntries.length ? selectedEntries[0] : null;
    this.props.onSetSelectedEntry(selectedEntry);
  };

  _handleRequestSubmit = async (): Promise<void> => {
    assert(this._canSubmit(), 'Unexpected submit');

    const selectedEntry = this.props.selectedEntry!;
    this.setState({currentlySubmitting: true});

    try {
      await this.props.onExecuteIntoExistingEntry(selectedEntry.id, this.props.fulfillments);
    } finally {
      this.setState({currentlySubmitting: false});
    }

    this.props.onRequestClose();
  };

  override render(): JSX.Element {
    const {selectedEntry} = this.props;
    return (
      <Modal
        buttons={[{text: 'Execute', submit: true, disabled: !this._canSubmit()}]}
        onRequestClose={this.props.onRequestClose}
        onRequestSubmit={() => {
          this._handleRequestSubmit();
        }}
        title="Select existing entry"
      >
        <EntrySearchInput
          onChange={this._handleSelectedEntriesChange}
          selectedEntries={selectedEntry ? [selectedEntry] : []}
          shouldAllowMultiple={false}
        />
      </Modal>
    );
  }
}

function mapStateToProps(state: BenchlingState, props: OwnProps): ConnectedProps {
  const {selectedEntry} = state.ui.requests.executeRequestFlow.existingEntry!;
  return {selectedEntry};
}
function mapDispatchToProps(dispatch: BenchlingDispatch): DispatchProps {
  return {
    onSetSelectedEntry: (selectedEntry: EntrySummary | null) => {
      dispatch(setSelectedEntry(selectedEntry));
    },
    onExecuteIntoExistingEntry: (entryId: string, fulfillments: Array<RequestFulfillmentDefinition>) =>
      dispatch(FulfillmentReduxActions.executeIntoExistingEntry(entryId, fulfillments)),
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(SelectExistingEntryModal);
